export default "__VITE_ASSET__B4q1xXO3__"